<template>
  <el-menu
    ref="menu"
    :class="[
      {
        'color--blue': menuColor == 'blue',
        'color--white': menuColor == 'white',
        'color--transparent': menuColor == 'transparent',

        'color--dark-blue':
          menuColor.length > 0 && menuColor.toLowerCase() == 'darkblue'
      },
      'dropdown-el'
    ]"
    mode="horizontal"
    @select="handleCommand"
    @open="handleOpen"
    @close="handleClose"
    menu-trigger="click"
  >
    <el-submenu index="1" class="submenu-1" v-click-outside="handleClose">
      <template slot="title">
        <span v-if="iconUrl || buttonText" class="dropdown-el--with-text">
          {{ buttonText }}
          <Picture v-if="iconUrl" :url="iconUrl" class="content-icon" />
        </span>
      </template>

      <div v-for="action in actions" :key="action.name">
        <el-menu-item
          v-if="action.id !== 'hrpac_candidates_mass_change_stage'"
          :index="action.id"
          class="dropdown-el__item"
        >
          <Picture
            v-if="action.icon"
            :url="action.icon"
            class="dropdown-el__item-icon"
          />
          <Icon
            v-else-if="action.id && actionIcons[action.id] && action.id != '0'"
            class="dropdown-el__item-icon"
            :iconName="actionIcons[action.id]"
            :iconColor="dropdownIconColor ? dropdownIconColor : '#0075DB'"
            :disabled="disabled"
          />
          <p class="dropdown-el__item-text">
            {{
              action.lbl && action.lbl.value ? action.lbl.value : action.name
            }}
          </p>
        </el-menu-item>

        <el-submenu
          v-if="action.id === 'hrpac_candidates_mass_change_stage'"
          :index="action.id"
          v-click-outside="handleClose"
          popper-append-to-body
        >
          <template slot="title">
            <span v-if="iconUrl || buttonText" class="dropdown-el__item">
              <Picture :url="action.icon" class="dropdown-el__item-icon" />
              <p class="dropdown-el__item-text">
                {{
                  action.lbl && action.lbl.value
                    ? action.lbl.value
                    : action.name
                }}
              </p>
            </span>
          </template>
          <el-menu-item
            v-for="(stage, idx) in stages"
            :key="idx"
            class="action dropdown-el__item"
            :disabled="!Boolean(Number(stage.fields[0].stage_access.value))"
            :index="`stage_${stage.fields[0].stage_name.value}`"
          >
            <Tooltip
              effect="dark"
              placement="top-start"
              popperClass="el-tooltip"
              :content="stage.fields[0].icon.tooltip"
              v-if="showTooltip(stage.fields[0])"
            >
              <div class="dropdown-el__tooltip">
                <Picture
                  v-if="stage.fields[0]?.icon?.value"
                  :url="stage.fields[0].icon.value"
                  :class="[
                    'dropdown-el__item-icon',
                    Boolean(Number(stage.fields[0].stage_access.value))
                      ? 'dropdown-el__item-icon--blue'
                      : 'dropdown-el__item-icon--grey'
                  ]"
                />
                <p class="black-text">{{ stage.fields[0].stage_name.value }}</p>
              </div>
            </Tooltip>
            <div class="dropdown-el__item" v-else>
              <Picture
                v-if="stage.fields[0]?.icon?.value"
                :url="stage.fields[0].icon.value"
                :class="[
                  'dropdown-el__item-icon',
                  Boolean(Number(stage.fields[0].stage_access.value))
                    ? 'dropdown-el__item-icon--blue'
                    : 'dropdown-el__item-icon--grey'
                ]"
              />
              <p class="black-text">{{ stage.fields[0].stage_name.value }}</p>
            </div>
          </el-menu-item>
        </el-submenu>
      </div>
    </el-submenu>
  </el-menu>
</template>
<script>
import { Menu, Submenu, MenuItem } from 'element-ui';
import { store } from '@/store';
import { eventBus } from '@/bus';
import Icon from 'Elements/Icon/Icon';
import { INTENT_AREA } from '@/utils/constants';
import { mixin, parseIntent, dialogMixin, errorMsg } from '@/utils/mixins';
import Picture from 'Elements/Picture/Picture';
import Tooltip from 'Elements/Tooltip/Tooltip';

export default {
  props: {
    actions: {
      type: Array,
      default: () => []
    },
    dropdownIconColor: {
      type: String,
      default: () => ''
    },
    menuColor: {
      type: String,
      default: 'transparent'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: ''
    },
    buttonText: {
      type: String,
      default: ''
    },
    iconUrl: {
      type: String,
      default: ''
    },
    hideOnClick: {
      type: Boolean,
      default: true
    }
  },
  mixins: [mixin, parseIntent, dialogMixin, errorMsg],
  created() {
    eventBus.$on(INTENT_AREA.CHECK_ACCESS, response =>
      this.checkAccess(response)
    );
    eventBus.$on(INTENT_AREA.DYNAMIC_PAGE, intent => {
      this.changePage(intent);
    });
    eventBus.$on(INTENT_AREA.SEND_REQUEST, response =>
      this.switchStage(response)
    );
  },
  beforeDestroy() {
    eventBus.$off(INTENT_AREA.CHECK_ACCESS, this.checkAccess);
    eventBus.$off(INTENT_AREA.SEND_REQUEST, this.switchStage);
    eventBus.$off(INTENT_AREA.DYNAMIC_PAGE);
  },
  data() {
    return {
      backgroundResumeLoading: false,
      actionIcons: {
        edit: 'Edit',
        edit_publish: 'Pen',
        delete: 'delete-trash',
        duplicate: 'Copy',
        toArchive: 'BoxDownload',
        publish: 'Upload',
        ReplyTo: 'Reply',
        ReplyToAll: 'ReplyAll',
        Forward: 'Forward',
        exit: 'Exit',
        refresh: 'Refresh'
      },
      selectedStage: null,
      userHasAccess: false
    };
  },
  computed: {
    attachmentButton() {
      return this.actions.find(
        elem => elem.id == 'hrpac_candidates_mass_add_to_vacancy'
      );
    },
    stages() {
      return store.state.candidate.vacancyCandidateStages;
    },
    selectedCandidates() {
      return store.state.massAction.selectedCandidates;
    }
  },
  methods: {
    changePage(intent) {
      if (
        intent.request?.request_params?.action == 'get_VacancyView' &&
        intent.request?.request_params?.module == 'HRPAC_VACANCY'
      ) {
        const id = intent.request?.request_params?.record || '';

        store.dispatch('vacancy/getMetadata', id);
      }
    },
    checkAccess(response) {
      if (response?.data?.status && response.data.status != 'ok') {
        this.showNotification({
          offset: 100,
          showClose: true,
          message: response?.data?.message || 'Нет доступа к смене этапов',
          duration: 6500,
          type: 'error'
        });
      } else if (!response) {
        this.showNotification({
          offset: 100,
          showClose: true,
          message: 'Ошибка при проверке доступа к смене этапов',
          duration: 6500,
          type: 'error'
        });
      }
    },
    switchStage(response) {
      if (response) {
        if (response.data?.successfully) {
          setTimeout(
            () =>
              this.showNotification({
                title: 'Этап подбора изменен',
                showClose: true,
                message: response.data.successfully,
                type: 'success',
                customClass: 'success-toast',
                position: 'top-left',
                duration: 6000,
                offset: 100
              }),
            100
          );
        }
        if (response.data?.unsuccessfully) {
          setTimeout(
            () =>
              this.showNotification({
                title: 'Этап подбора не изменен',
                showClose: true,
                message: response.data.unsuccessfully,
                type: 'error',
                position: 'top-left',
                duration: 6000,
                offset: 100
              }),
            100
          );
        }
      } else {
        this.showNotification({
          offset: 100,
          showClose: true,
          message: 'Ошибка при переводе на этап',
          duration: 6500,
          type: 'error'
        });
      }
    },
    showTooltip(stage) {
      return (
        stage?.icon && stage?.icon?.tooltip && Boolean(stage.stage_access.value)
      );
    },
    handleCommand(arg) {
      if (arg.includes('stage')) {
        let stage = this.stages.find(
          elem => elem.fields[0].stage_name.value == arg.split('_')[1]
        );
        if (stage && stage?.intents) {
          this.selectedStage = stage;
          store.commit('event/setIntents', stage.intents);
          this.parse();
        }
      } else {
        this.$emit(
          'handleCommand',
          this.actions.find(elem => elem.id == arg)
        );
      }
    },
    getIcon(direction, available) {
      return available
        ? direction === 'backward'
          ? 'FullArrowLeft'
          : 'FullArrowRight'
        : 'Lock';
    },
    async handleOpen(idx) {
      if (idx == 'hrpac_candidates_mass_change_stage') {
        let resp = await store.dispatch(
          'candidate/loadCandidateStages',
          this.actions.find(elem => elem.id == idx).intents
        );
        if (resp) {
          this.$refs['menu'].closeMenu('hrpac_candidates_mass_change_stage');
        }
      }
    },
    handleClose() {
      if (this.$refs.menu.openedMenus.length) {
        this.$refs['menu'].closeMenu('1');
        this.$refs['menu'].closeMenu('hrpac_candidates_mass_change_stage');
      }
    }
  },
  components: {
    'el-menu': Menu,
    'el-submenu': Submenu,
    'el-menu-item': MenuItem,
    Icon,
    Picture,
    Tooltip
  }
};
</script>

<style lang="scss" scoped>
.content-icon {
  filter: $greyPicture;
}

.dropdown-el {
  height: 40px;
  border: none;
  border-radius: 4px;
  background: $white;

  &:hover {
    outline: 1px solid $blue40;
  }

  &:focus {
    outline: 2px solid $blue80;
  }

  &--with-text {
    padding: 0 12px;
  }

  .img {
    width: 24px;
    height: 24px;
  }

  span {
    cursor: pointer;
    color: $grey40;
    font-family: 'Roboto Medium';
    font-size: 16px;
    line-height: 24px;
    display: flex;
    gap: 6px;
  }

  &__item {
    display: flex;
    flex-direction: row;
    align-items: center;
    min-height: 40px;
    border-radius: 4px;
    cursor: pointer;

    &-icon {
      margin-right: 8px;
      filter: $greyPicture;

      &--blue {
        filter: $bluePicture;
      }

      &--grey {
        filter: $greyPicture;
      }
    }

    &-text {
      margin: 0;
      color: $black-190;
      font-size: 15px;
      font-family: 'Roboto', sans-serif;
      line-height: 24px;
      cursor: pointer;
    }
  }

  &__tooltip {
    display: flex;
    width: 100%;
  }

  &__list {
    margin: 0 !important;
  }

  & ::v-deep .el-submenu.is-active {
    & > .el-submenu__title {
      border-bottom-color: transparent;
    }
  }

  &:hover {
    & ::v-deep .el-submenu__title {
      border-radius: 4px;
    }
  }
}

.el-submenu {
  & ::v-deep i {
    display: none;
  }
}

.el-menu:not(.actions-btn-wrapper):not(.apply-btn-menu) {
  box-shadow: none !important;
}

.menu-item {
  color: $black-200 !important;
  padding: 0 12px !important;
  height: 48px !important;
  gap: 8px;
  display: flex;
  align-items: center;

  span {
    cursor: pointer;
  }

  &.is-opened {
    background: #e9edf2;
  }

  &.is-disabled {
    opacity: 1;

    & ::v-deep span {
      opacity: 0.25;
    }
  }

  .loader {
    background: none;
    width: 24px !important;
    height: 24px !important;

    & ::v-deep .circular {
      background: none;
      width: 24px !important;
      height: 24px !important;
    }
  }

  &:hover {
    background: $grey8;
  }

  & ::v-deep .el-submenu__title {
    padding: 0;
    color: $grey80;
    background: transparent;
  }

  & ::v-deep .el-submenu__icon-arrow {
    right: -25px;
    margin-top: -5px;
  }

  & ::v-deep .action {
    padding: 0 12px;
    gap: 12px;
    display: flex;
    align-items: center;

    span {
      cursor: pointer;
    }

    &:hover {
      background: #e9edf2;
    }
  }

  & ::v-deep .action.disabled {
    background: #dadfe4;
    color: #99a5b3;
  }
}

.submenu-1 {
  height: inherit;
  width: 100%;

  .el-submenu-icon {
    margin: 0;
  }

  & ::v-deep .el-submenu__title {
    width: 100%;
    height: 100%;
    padding: 0px !important;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  & ::v-deep i {
    display: none;
  }
}

.black-text {
  pointer-events: none;
  color: $black-200 !important;
  line-height: 40px;
}
</style>
